// extracted by mini-css-extract-plugin
export default {"container":"z1-z","list":"A1-z"};